import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { ConfirmDialogComponent } from '../dialog/confirm-dialog/confirm-dialog.component'
import { ChiliImageDeleteButtonComponent } from './chili-image-delete-button.component'

@NgModule({
    declarations: [ChiliImageDeleteButtonComponent],
    imports: [CommonModule, ConfirmDialogComponent, MatButtonModule, MatIconModule, MatSnackBarModule],
    exports: [ChiliImageDeleteButtonComponent],
})
export class ChiliImageDeleteButtonModule {}
